import React from 'react'
import './About.css'
import bg from "../../../Images/About2.jpg"
import about from "../../../Images/About1.jpg"
import store from "../../../Images/About7.jpg"
import owner from "../../../Images/jegan.jpeg"
import year from "../../../Images/About3.jpg"
import customer from "../../../Images/About5.jpg"
import design from "../../../Images/About8.jpg"
import trust from "../../../Images/About9.jpg"

const About = () => {
  return (
    <div>
      {/* ---------------------------------------------- Hero / Banner Section ------------------------------- */}
  <section className="about-hero-section"
  style={{
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100vh",
  }}
>
  <div className="hero-overlay">
    <div className="container hero-content">
      <div className="hero-flex">
        {/* left SIDE — TEXT */}
        <div className="hero-text">
          <h1 className="display-4 fw-bold mb-3">About Us</h1>
          <h4>Your Family Fashion Destination</h4>
          <p className="lead mb-4">
            Akshayam Silks & Readymades brings style comfort and trust to every collection.
            We combine traditional designs with modern trends to create clothing for kids, ladies, men, and
            premium cosmetics. Every piece is crafted with quality and care to make shopping a delightful experience.
          </p>
          <div className="about-hero-buttons">
            <a href="/gallery" className="btn btn-lg btn-about-custom">View Gallery</a>
            <a href="/contactus" className="btn btn-lg btn-about-custom">Contact Now</a>
          </div>
        </div>

        {/* right SIDE — IMAGE */}
        <div className="hero-image">
          <img src={about} alt="Akshayam Textiles" className="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</section>

{/* ------------------------------------------------ Introduction Section ---------------------------------------- */}
<section className="ourstory-section py-5">
  <div className="ourstory-container">
    <div className="ourstory-flex">
      {/* RIGHT — TEXT */}
      <div className="ourstory-text">
        <h2 className="mb-4">Our Story</h2>
        <p className="lead">
         Founded in 1999 Akshayam Silks & Readymades has been a name of trust and quality in the textile industry.
         With over 25 years of experience we’ve dressed generations with the latest trends in kids ladies
          and mens fashion along with exclusive cosmetic collections.
        </p>
        <p>
          Our journey began with a passion for fabrics and a promise to deliver excellence. Today, we continue
          to combine tradition with innovation, offering products that bring comfort and confidence to every
          customer.
        </p>
        <div className="vision-mission">
          <h4>Vision & Mission:</h4>
          <p><strong>Vision:</strong> Deliver stylish, comfortable, and high-quality clothing for every generation.</p>
          <p><strong>Mission:</strong> Maintain a legacy of excellence and bring the finest fabric collections to customers.</p>
        </div>
      </div>

      {/* LEFT — IMAGE */}
      <div className="ourstory-image">
        <img src={store} alt="Akshayam Textiles Store" className="img-fluid"/>
      </div>
    </div>
  </div>
</section>

{/* ---------------------------------------- Meet the Owner Section ----------------------------------------- */}
      <section className=" Owner-Section py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">The Heart of Akshayam Silks & Readymades</h2>
          <p className="text-center lead mb-5">
            "Every great fabric has a story and ours is crafted by people with passion."
          </p>
          <div className="row align-items-center justify-content-center">
            <div className="col-md-4 text-center mb-4 mb-md-0">
              <img
                src={owner}
                className="img-fluid rounded-circle owner-profile-img"
                alt="Mr. Jegan v"
                style={{ width: "200px", height: "200px" }}
              />
              <h4 className="mt-3">Mr. Jegan V</h4>
              <p className="text-muted">Founder & Managing Director</p>
            </div>
            <div className="col-md-8">
              <p>
               Mr. Jegan V founded Akshayam Silks & Readymades in 1999 with a clear vision to bring premium 
               quality fabrics and fashionable wear to every family. With over 25
                years of dedication he transformed a small local shop into a trusted destination for 
                clothing and cosmetics blending tradition with trend.
              </p>
              <p>
                His commitment to quality fair pricing and customer satisfaction has been the driving 
                force behind our success. Under his leadership Akshayam Silks & Readymades continues to grow 
                inspiring future generations to uphold the same values of trust and craftsmanship.
              </p>
              <blockquote className="blockquote mt-4 border-start border-warning ps-3">
                <p className="mb-0 fst-italic">
                  "I believe that every piece of fabric carries warmth comfort and emotion. Our goal
                   is not just to sell clothes but to weave happiness into every purchase."
                </p>
                <footer className="blockquote-foot">Mr. Jegan V</footer>
              </blockquote>
            </div>
          </div>
        </div>
      </section>

{/* --------------------------------------- Achievements / Milestones ----------------------------------------- */}
      <section className="achievements-section py-5">
        <div className="container">
          <h3 className="text-center mb-5">Achievements / Milestones</h3>
          <div className="row text-center">
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="milestone-item">
                <img src={year} alt="Since 1999" className="mb-3" />
                <h5 className="fw-bold">Serving Customers Since 1999</h5>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="milestone-item">
                <img src={customer} alt="Happy Customers" className="mb-3" />
                <h5 className="fw-bold">10,000+ Happy Customers</h5>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="milestone-item">
                <img src={design} alt="Designs" className="mb-3" />
                <h5 className="fw-bold">500+ Unique Fashion Designs</h5>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div className="milestone-item">
                <img src={trust} alt="Trust" className="mb-3" />
                <h5 className="fw-bold">Trusted by Families Across Generations</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* ------------------------------------------- Call-to-Action Section -------------------------------------- */}
<section className="discover-section py-5">
  <div className="container text-center">
    <h2 className="mb-4">
      Discover our latest collection and experience the comfort of Akshayam Silks & Readymades.
    </h2>
    <div className="d-flex justify-content-center gap-3">
      <a href="/gallery" className="btn btn-lg btn-custom">View Gallery</a>
      <a href="/contact" className="btn btn-lg btn-custom">Contact Us</a>
    </div>
  </div>
</section>
      
    </div>
  )
}

export default About
